import { ChangeEvent, Dispatch, ReactNode, SetStateAction } from "react";
import { InputHookResult } from "shared/hooks/useInputState";
import { Translations } from "shared/types/languages";

export type FaqGroupDetailsType = {
  isLoading: boolean;
  isSubmitting: boolean;
  groupTitle?: InputHookResult;
  selectedTab: FaqGroupDetailsTabs;
  setSelectedTab: Dispatch<SetStateAction<FaqGroupDetailsTabs>>;
  translations?: Translations;
  setTranslations: Dispatch<SetStateAction<Translations | undefined>>;
  errors: string;
  setErrors: Dispatch<SetStateAction<string>>;
  disabled: boolean;
  onChangeGroupTitle: (e: ChangeEvent<HTMLInputElement>) => void;
  onCloseFaqGroupDetails: () => void;
  handleSaveDraft: () => void;
  handleSaveActive: () => void;
  handleSaveTranslations: () => void;
};

export type FaqGroupDetailsProviderProps = {
  children: ReactNode;
};

export enum FaqGroupDetailsTabs {
  General,
  Translations,
}

export enum ManagedTranslations {
  GroupName = "Group name",
}